import { MeetingDays } from "../../../common/dtos/classes.type";

export function parseDate(dateString: string): {
  weekday: string;
  date: number;
} {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const weekday = weekdays[date.getUTCDay()];
  const dateNumber = date.getUTCDate();

  return {
    weekday,
    date: dateNumber,
  };
}

interface Event {
  start_date: string;
  [key: string]: any;
}

interface MonthGroup {
  title: string;
  items: Event[];
}

export function groupEventsByMonth(events: Event[]): MonthGroup[] {
  const groupedEvents = events.reduce((grouped, event) => {
    const startDate = new Date(event.start_date);
    const monthName = startDate.toLocaleString("default", { month: "long" });
    const year = startDate.getFullYear();

    if (!grouped[monthName]) {
      grouped[monthName] = {
        title: `${monthName} ${year}`,
        items: [],
      };
    }

    grouped[monthName].items.push(event);
    return grouped;
  }, {} as Record<string, MonthGroup>);

  // Custom month order putting current/future months first
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const monthOrder = [
    "November",
    "December",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
  ];

  return monthOrder
    .filter((month) => groupedEvents[month])
    .map((month) => {
      const monthEvents = groupedEvents[month];
      const eventYear = new Date(monthEvents.items[0].start_date).getFullYear();

      return {
        ...monthEvents,
        title: `${month} ${eventYear}`,
        items: monthEvents.items.sort(
          (a, b) =>
            new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
        ),
      };
    });
}

export function isMultipleDays(eventDays: MeetingDays): boolean {
  let trueCount = 0;

  for (const day in eventDays) {
    if (eventDays[day as keyof MeetingDays]) {
      trueCount++;
      if (trueCount > 1) {
        return true;
      }
    }
  }

  return false;
}
